import { FunctionComponent, useState } from 'react'
import { Box, Divider, Typography } from '@material-ui/core'
import SignUp from './SignUp'
import { SignInLinkedIn, SignInEmail } from './components/sign-in'
import { ResetPassword } from './components/sign-in/ResetPassword'
import { BackendUser, UserRoles } from 'common/types'
import { SignInMessage } from './components/sign-in/SignInMessage'
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { BubbleTabs } from 'components/core/tabs/BubbleTabs'

const StyledDivider = styled(Divider)`
  && {
    background-color: ${props => props.theme.colors.accent};
    margin: 0 auto;
  }
`

const StyledBox = styled(Box)`
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  text-align: center;
  width: 100%;
`
interface SignUpProps {
  title?: string
  tabIndex: number
  selectedPage: number
  setSelectedPage: Function
  setSelectedTab?: Function
  onSubmit: Function
  mode: UserRoles
  username?: string
  password?: string
  setUsername?: Function
  setPassword?: Function
  onLogin: Function
  user: BackendUser
  confirmEmail?: Function
  errorCount?: number
  setErrorCount?: Function
  setShowTicketModal?: Function
  success?: boolean
  setSuccess?: Function
  setForwardingUrl?: Function
  timer: number
  setTimer: Function
  errorFlag: boolean
  setErrorFlag: Function
  errorMessage: string
  setErrorMessage: Function
  getItem: Function
  clearItem: Function
  showConfirmEmailModal: boolean
  setShowConfirmEmailModal: Function
  isLocked: boolean
  setIsLocked: Function
  handleUsernameChange: Function
  resendConfirmationCode: Function
}

const Index: FunctionComponent<SignUpProps> = ({
  username,
  password,
  setUsername,
  setPassword,
  tabIndex,
  setSelectedTab,
  mode,
  onSubmit,
  selectedPage,
  setSelectedPage,
  onLogin,
  user,
  confirmEmail,
  errorCount,
  setErrorCount,
  timer,
  setTimer,
  errorFlag,
  setErrorFlag,
  errorMessage,
  setErrorMessage,
  getItem,
  clearItem,
  showConfirmEmailModal,
  setShowConfirmEmailModal,
  isLocked,
  setIsLocked,
  handleUsernameChange,
  resendConfirmationCode
}) => {
  const theme = useTheme()
  const tabs: string[] = mode === UserRoles.Member ? ['Sign In', 'Sign Up'] : ['Login ', 'Become a Partner']
  const { isDevice } = useScreenSizes()
  const [showEmailLogin, setShowEmailLogin] = useState(false)
  const toggleEmailLogin = () => {
    setShowEmailLogin(!showEmailLogin)
  }

  return (
    <>
      <BubbleTabs
        tabs={tabs}
        view={'sign-up'}
        activeTab={tabIndex}
        setActiveTab={setSelectedTab}
        margin="0.5em 1.5em 1.5em 1.5em"
        width={isDevice ? '80vw' : '450px'}
        setShowConfirmEmail={setShowConfirmEmailModal}
        tabColor={theme.colors.primary}
      />
      <StyledBox maxHeight={isDevice ? '60vh' : '70vh'}>
        {tabIndex === 0 && selectedPage === 0 && (
          <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <SignInMessage mode={mode} onSignUp={() => onLogin(1)} />
            <SignInLinkedIn showEmailLogin={toggleEmailLogin} mode={mode} onSignUp={() => onLogin(1)} />

            <Box maxWidth="100%" display="flex" justifyContent="center">
              <StyledDivider style={{ width: isDevice ? '350%' : '490%' }} />
              <Typography variant="caption">
                <Box color={theme.colors.accent} position="relative" top="-0.8em" padding="0 1em">
                  OR
                </Box>
              </Typography>
              <StyledDivider style={{ width: isDevice ? '350%' : '490%' }} />
            </Box>
            <SignInEmail
              username={username}
              password={password}
              setUsername={setUsername}
              setPassword={setPassword}
              onSubmit={() => onSubmit('signIn', mode)}
              setSelectedPage={setSelectedPage}
              confirmEmail={confirmEmail}
              mode={mode}
            />
          </Box>
        )}
        {tabIndex === 0 && selectedPage === 1 && (
          <Box m="0 auto" p="1em" width='80%'>
            <ResetPassword onSubmit={e => onSubmit('passwordReset', mode, e)} setSelectedPage={setSelectedPage} />
          </Box>
        )}
        {tabIndex === 1 && (
          <SignUp
            onLogin={() => onLogin(0)}
            mode={mode}
            username={username}
            password={password}
            setUsername={setUsername}
            setPassword={setPassword}
            onSubmit={(email: string) => onSubmit('signUp', mode, email)}
            user={user}
            confirmEmail={confirmEmail}
            errorCount={errorCount}
            setErrorCount={setErrorCount}
            timer={timer}
            setTimer={setTimer}
            errorFlag={errorFlag}
            setErrorFlag={setErrorFlag}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            getItem={getItem}
            clearItem={clearItem}
            showConfirmEmailModal={showConfirmEmailModal}
            setShowConfirmEmailModal={setShowConfirmEmailModal}
            resendConfirmationCode={resendConfirmationCode}
            isLocked={isLocked}
            setIsLocked={setIsLocked}
            handleUsernameChange={handleUsernameChange}
          />
        )}
      </StyledBox>
    </>
  )
}
export default Index
